import React from 'react';

const NotFound = () => {
  return <div>페이지를 찾을 수 없습니다.</div>;
};

export default NotFound;
